import { DhamhaAungLanLogo } from "@/components/common/icons";
import { Button } from "antd";
import { useState } from "react";
import { AiOutlineLeft } from "react-icons/ai";
import { Link } from "react-router";
import { AskNewPassword } from "./AskNewPassword";
import { AskOTPCode } from "./AskOTPCode";
import { AskPhoneNumber } from "./AskPhoneNumber";

enum STEP {
    askPhoneNumber = "askPhoneNumber",
    verifyPhoneNumber = "verifyPhoneNumber",
    createNewPassword = "createNewPassword",
}

export function ForgotPassword() {

    const [chechPhoneNumberResponse, setCheckPhoneNumberResponse] = useState<CheckPhoneNumberResponse | null>(null);
    const [step, setStep] = useState<STEP>(STEP.askPhoneNumber);

    return (
        <>
            <div
                className="max-w-md w-full p-8 rounded-md bg-white backdrop-blur-md shadow-lg space-y-8"
            >
                <article
                    className=" space-y-4 flex flex-col items-center"
                >
                    <DhamhaAungLanLogo />
                    {/* <h2
                        className="text-base text-primary-gradient"
                    >
                        ဓမ္မအောင်လံ ဝိပဿနာရိပ်သာ
                    </h2> */}
                </article>

                {
                    step === STEP.askPhoneNumber && (
                        <AskPhoneNumber
                            handleNextStep={(data: CheckPhoneNumberResponse) => {
                                setCheckPhoneNumberResponse(data);
                                setStep(STEP.verifyPhoneNumber);
                            }}
                        />
                    )
                }

                {
                    step === STEP.verifyPhoneNumber && (
                        <AskOTPCode
                            requestId={chechPhoneNumberResponse?.requestId || 0}
                            phone={chechPhoneNumberResponse?.phone || ""}
                            handleNextStep={() => setStep(STEP.createNewPassword)}
                            onUpdateRequestId={(data: CheckPhoneNumberResponse) => setCheckPhoneNumberResponse(data)}
                        />
                    )
                }

                {
                    step === STEP.createNewPassword && (
                        <AskNewPassword />
                    )
                }

                <Link
                    to={"/login"}
                    replace
                >
                    <Button
                        size="large"
                        type="text"
                        htmlType="button"
                        className="!font-poppins !mx-auto !w-fit !flex mt-10 "
                        icon={
                            <AiOutlineLeft />
                        }
                    >
                        Back
                    </Button>
                </Link>
            </div>
        </>
    )
}
